/**
 * Validation des variables d'env critiques au boot.
 *
 * @remarks
 * Fail-fast avec message clair plutôt qu'un crash tardif sur `baseURL: undefined`
 * ou `fetch('undefined/api/...')`. Appelé dans `main.tsx` avant `createRoot`.
 *
 * **En dev** : `VITE_API_URL` est optionnelle (le proxy Vite avec `target: env.VITE_API_URL ?? 'http://localhost:3000'` couvre, cf. `vite.config.ts`).
 * **En prod** : exigée — sinon `BASE_URL` (cf. `lib/http/client.ts`) sera `undefined` et toutes les requêtes partiront en cacahuète.
 */

export function validateEnv(): void {
  const apiUrl = import.meta.env.VITE_API_URL;

  // Si fournie, doit être parseable comme URL (catch les `htps://...`,
  // les `localhost:3000` sans scheme, etc.).
  if (apiUrl !== undefined && apiUrl !== '') {
    try {
      new URL(apiUrl);
    } catch {
      throw new Error(
        `[env] VITE_API_URL "${apiUrl}" n'est pas une URL valide. ` +
          `Format attendu : 'https://saas.gateway.alt-tools.tech/' (cf. .env.example).`,
      );
    }
  }

  // En prod, la var doit être définie et non vide.
  if (import.meta.env.PROD && (apiUrl === undefined || apiUrl === '')) {
    throw new Error(
      `[env] VITE_API_URL est requise en build prod (Vite la bake au build). ` +
        `Ajoute la var dans .env ou dans la pipeline CI avant 'pnpm build'.`,
    );
  }
}
